import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ActionCentre from "@/pages/ActionCentre";
import Merchandise from "@/pages/Merchandise";
import Option360 from "@/pages/Option360";
import Sku360 from "@/pages/Sku360";
import Inventory from "@/pages/Inventory";
import UploadCentre from "@/pages/UploadCentre";
import DataHealth from "@/pages/DataHealth";
import Admin from "@/pages/Admin";
import Engines from "@/pages/Engines";
import Planning from "@/pages/Planning";
import Allocation from "@/pages/Allocation";
import Performance from "@/pages/Performance";
import Reports from "@/pages/Reports";
import { Loader } from "@/components/common";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Loader testId="auth-loader" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="/actions" element={<ActionCentre />} />
              <Route path="/merchandise" element={<Merchandise />} />
              <Route path="/options/:code" element={<Option360 />} />
              <Route path="/skus/:code" element={<Sku360 />} />
              <Route path="/inventory/:tab" element={<Inventory />} />
              <Route path="/inventory" element={<Navigate to="/inventory/overview" replace />} />
              <Route path="/engines" element={<Engines />} />
              <Route path="/planning" element={<Planning />} />
              <Route path="/allocation" element={<Allocation />} />
              <Route path="/performance" element={<Performance />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/data/upload" element={<UploadCentre />} />
              <Route path="/data/health" element={<DataHealth />} />
              <Route path="/admin" element={<Admin />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
